export const ENDPOINTS = {
  CREATE_META_SITE: '/api/create-meta-site',
  UPLOAD_SITE_MEDIA: '/api/upload-site-media',
  GENERATE_MOCKUPS: '/api/generate-mockups',
  ATTACH_SITE_TEMPLATE: '/api/attach-site-template',
  INSTALL_SITE_APPS: '/api/install-site-apps',
  PUBLISH_SITE: '/api/publish-site',
  RESET_STORE: '/api/reset-store',
  GET_SITE_URLS: '/api/get-site-urls',
  ADD_STORE_PRODUCTS: '/api/add-store-products',
  GET_PRODUCTS_COUNT: '/api/get-products-count',
  INJECT_COMPONENT_CORE: '/api/inject-component-core',
};
